import { CsvArray, Federation, Meet } from "types";
// import { exportUSAPLResults } from "./usapl";

type FedConfig = {
  fullName: string;
  fourthAttempts: boolean;
  exportResults?: (meet: Meet, dataArray: any) => CsvArray;
};

export const federationConfigs: Record<Federation, FedConfig> = {
  "100RAW": { fullName: "100% Raw Powerlifting", fourthAttempts: true },
  APA: { fullName: "APA", fourthAttempts: false },
  CPU: { fullName: "Canadian Powerlifting Union", fourthAttempts: false },
  IPA: {
    fullName: "International Powerlifting Association",
    fourthAttempts: true,
  },
  IPF: {
    fullName: "International Powerlifting Federation",
    fourthAttempts: false,
  },
  MMP: { fullName: "Metal Militia Powerlifting", fourthAttempts: true },
  RPS: { fullName: "Revolution Powerlifting Syndicate", fourthAttempts: true },
  SSF: { fullName: "Svenska Styrkelyftförbundet", fourthAttempts: false },
  USAPL: {
    fullName: "USA Powerlifting",
    fourthAttempts: false,
  },
  USPA: {
    fullName: "United States Powerlifting Association",
    fourthAttempts: true,
  },
  USSF: { fullName: "US Strengthlifting", fourthAttempts: false },
  WPP: { fullName: "World Para Powerlifting", fourthAttempts: false },
  WRPF: {
    fullName: "World Raw Powerlifting Federation",
    fourthAttempts: false,
  },
  OTHER: { fullName: "Other", fourthAttempts: true },
} as const;
